import axios from "axios";
const BASIC_API = process.env.REACT_APP_BASIC_API + "/UserActivityLog";

class UserActivityLogService {
    // create(data) {
    //     let token;
    //     JSON.parse(localStorage.getItem("biodnd_admin_token"))
    //     ? token = JSON.parse(localStorage.getItem("biodnd_admin_token")).token
    //     : token = "";

    //     return axios.post(`${BASIC_API}`, {
    //         data
    //     }, {
    //         headers: {Authorization: `Bearer ${token}`}
    //     });
    // }

    search(userId, activityType, page, startAt = "", endAt = "") {
        let token;
        JSON.parse(localStorage.getItem("biodnd_admin_token"))
        ? token = JSON.parse(localStorage.getItem("biodnd_admin_token")).token
        : token = "";

        return axios.post(`${BASIC_API}/Search`, 
            {
                userId,
                activityType,
                startAt,
                endAt,
                "pageRequestParameter": {
                    "isReturnAllDataAndNoPage": false,
                    "targetPage": page,
                    "showCount": 10
                }
            }, {
            headers: {Authorization: `Bearer ${token}`}
        });
    }

    searchLatestOnePerUser(search, activityType, page, startAt = "", endAt = "") {
        let token;
        JSON.parse(localStorage.getItem("biodnd_admin_token"))
        ? token = JSON.parse(localStorage.getItem("biodnd_admin_token")).token
        : token = "";

        return axios.post(`${BASIC_API}/SearchLatestOnePerUser`, 
            {
                search,
                activityType,
                startAt,
                endAt,
                "pageRequestParameter": {
                    "isReturnAllDataAndNoPage": false,
                    "targetPage": page,
                    "showCount": 10
                }
            }, {
            headers: {Authorization: `Bearer ${token}`}
        });
    }

    // update(companyId, data) {
    //     let token;
    //     JSON.parse(localStorage.getItem("biodnd_admin_token"))
    //     ? token = JSON.parse(localStorage.getItem("biodnd_admin_token")).token
    //     : token = "";

    //     return axios.put(`${BASIC_API}/${companyId}`, {
    //         data
    //     }, {
    //         headers: {Authorization: `Bearer ${token}`}
    //     });
    // }

    // getDetails(companyId) {
    //     let token;
    //     JSON.parse(localStorage.getItem("biodnd_admin_token"))
    //     ? token = JSON.parse(localStorage.getItem("biodnd_admin_token")).token
    //     : token = "";

    //     return axios.get(`${BASIC_API}/${companyId}`, {
    //         headers: {Authorization: `Bearer ${token}`}
    //     });
    // }

    // delete(companyId) {
    //     let token;
    //     JSON.parse(localStorage.getItem("biodnd_admin_token"))
    //     ? token = JSON.parse(localStorage.getItem("biodnd_admin_token")).token
    //     : token = "";

    //     return axios.delete(`${BASIC_API}/${companyId}`, {
    //         headers: {Authorization: `Bearer ${token}`}
    //     });
    // }

    // uploadImages(formData) {
    //     let token;
    //     JSON.parse(localStorage.getItem("biodnd_admin_token"))
    //     ? token = JSON.parse(localStorage.getItem("biodnd_admin_token")).token
    //     : token = "";

    //     return axios.post(`${BASIC_API}/UploadHandler.ashx`,
    //         formData, {
    //             headers: {Authorization: `Bearer ${token}`}
    //         }
    //     );
    // }

    exportToExcel(data) {
        let token;
        JSON.parse(localStorage.getItem("biodnd_admin_token"))
        ? token = JSON.parse(localStorage.getItem("biodnd_admin_token")).token
        : token = "";

        return axios.post(`${BASIC_API}/ExportExcel`, 
            {
                ...data,
                "pageRequestParameter": {
                    "isReturnAllDataAndNoPage": true,
                    "targetPage": 1,
                    "showCount": 10
                }
            }, {
            headers: {Authorization: `Bearer ${token}`}
        });
    }
}

const NewUserActivityLogService = new UserActivityLogService();
export default NewUserActivityLogService;